import { useAbility } from '@cast/shared-ability-data-access';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useIsOrganizationAuditLogVisible = () => {
  const { can } = useAbility();
  const { currentOrganization } = useOrganizations();
  return (
    (can('view', 'OrganizationAuditLog') || currentOrganization?.internal) ??
    false
  );
};
